import { currency, discountIsValid, timeAgo } from "../../utils/mappers";
import { Card, Image } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { FiGrid } from "react-icons/fi";

import "./styles.scss";
import { getImage } from "../../services/api";




export default function ProductCard({ product }) {
  const history = useHistory();

  const showDiscountInfo = product.price_on_offer == 1 ? true : false;


  return (
    <div className="card-container" style={{ position: 'relative' }}>
    <Card
      className="my-1 card-product"
      title={`Ver detalhes de ${product.name}`}
      onClick={() => {
        window.open(`https://cacadores-de-ofertas.com/produto/${product.id}`, '_blank'); // Abre em uma nova aba
      }}
     
    >
      <Image src={(product.image_url)} className="product-card-image" />
      {product.partner && product.partner.image_url && (
        <div className="partner-logo-container">
          <Image src={product.partner.image_url} className="partner-logo" alt={`Logo de ${product.partner.name}`} />
        </div>
      )}
 {product.ribbon_badges && product.ribbon_badges.length > 0 && (
          <div className="ribbon-badge" style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              backgroundColor: product.ribbon_badges[0].color,
              color: '#fff',
              padding: '5px 20px',
              fontSize: '14px',
              fontWeight: 'bold',
              borderRadius: '0 10px 10px 0', // Arredondado em um lado para estilo
              boxShadow: '0 2px 4px rgba(0,0,0,0.25)'
          }}>
            {product.ribbon_badges[0].name}
          </div>
        )}



      <Card.Body>
        <Card.Title className="" style={{ fontWeight: 'bold', fontSize: '17px', color: 'black' }}>


          {product.name}



        </Card.Title>


        Postado {timeAgo(product.created_at)}


        {product.previous_price && showDiscountInfo && (
          <p className="old-price">{currency(product.previous_price)}</p>
        )}
        <div className=" price h6" style={{ fontWeight: 'bold', fontSize: '25px', color: 'green' }}>
          {currency(
            showDiscountInfo ? product.offer_price : product.previous_price
          )}

          {showDiscountInfo && (
            <span className="h6 bg-primary text-light p-1 rounded ml-2" style={{ fontSize: '11px' }}>Oferta </span>
          )}
        </div>




        {product.categoryName && (

          <div className="d-flex justify-content-center align-items-center">
            <FiGrid className="text-muted" size={16} />
            <span className="ml-1 text-muted">{product.categoryName}</span>
          </div>

        )}

      </Card.Body>
    </Card>
    </div>
  );
}
